import outdent from "outdent";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const marketoEngage = defineConnector({
  identifier: "marketoEngage",
  name: "Marketo Engage",
  tagLine: "Marketing automation platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ accountId }) =>
    urlToPattern(accountId, "^https://.*\\.mktorest\\.com/.*"),
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Marketo account ID",
      items: [
        {
          kind: "markdown",
          content: outdent`
            Find your base URL in Marketo under **Admin > Integration > Web Services**.
          `,
        },
        {
          kind: "url",
          label: "Account ID / base URL",
          target: { kind: "configuration", field: "accountId" },
          placeholder: "e.g. 284-RPR-133.mktorest.com",
          required: true,
        },
      ],
    },
    {
      title: "Enter your OAuth credentials",
      items: [
        {
          kind: "markdown",
          content: outdent`
            The Client ID and Client Secret are found in **Admin > Integration > LaunchPoint** by selecting the custom service and clicking **View Details**.
          `,
        },
        {
          kind: "input",
          label: "Client ID",
          target: { kind: "oauthConnection", field: "clientId" },
          placeholder: "Paste your Client ID",
          required: true,
        },
        {
          kind: "input",
          label: "Client secret",
          target: { kind: "oauthConnection", field: "clientSecret" },
          placeholder: "Paste your Client secret",
          required: true,
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ accountId }) => `${accountId}/identity/oauth/token`,
    scopes: () => [],
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
  },
  connectionTest: {
    protocol: "http",
    request: ({ accountId }) => `${accountId}/rest/v1/leads/describe.json`,
  },
});
